export const adyenConfig = {
	locale: 'en_US',
	showPayButton: true,
	paymentMethodsConfiguration: {
		card: {
			hasHolderName: true,
			holderNameRequired: true,
			enableStoreDetails: false,
			hideCVC: false,
			name: 'Credit or debit card'
		}
	}
};



// WEBPACK FOOTER //
// ./components/payments/adyen/Adyen/config.js